import React, { useState } from "react";
import BlueImage from "../../assets/images/blue.jpeg";
const ArrayVideo = [
  {
    id: 1,
    title: "المقدمة",
    link: "https://www.youtube.com/embed/XHQ_X3HWLJ0",
    thumbnail: "https://i.ytimg.com/vi/XHQ_X3HWLJ0/mqdefault.jpg",
  },
  {
    id: 2,
    title: "المقدمة",
    link: "https://www.youtube.com/embed/BwHeHbYD8C8",
    thumbnail: "https://i.ytimg.com/vi/BwHeHbYD8C8/mqdefault.jpg",
  },
  {
    id: 3,
    title: "المقدمة",
    link: "https://www.youtube.com/embed/E1Q-P0Yk3j0",
    thumbnail: "https://i.ytimg.com/vi/E1Q-P0Yk3j0/mqdefault.jpg",
  },
  {
    id: 4,
    title: "المقدمة",
    link: "https://www.youtube.com/embed/BwHeHbYD8C8",
    thumbnail: "https://i.ytimg.com/vi/BwHeHbYD8C8/mqdefault.jpg",
  },
];

function VideoHeader() {
  const [selectedVideo, setSelectedVideo] = useState(ArrayVideo[0]);
  return (
    <div className="container my-5 w-100 ">
      <iframe
        width="100%"
        height="500px"
        src={selectedVideo.link}
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
        className="rounded-4"
      ></iframe>
    </div>
  );
}

export default VideoHeader;
